var _feGaussianBlur, _feGaussianBlur2, _feGaussianBlur3, _feGaussianBlur4, _feGaussianBlur5, _feGaussianBlur6, _feGaussianBlur7, _feGaussianBlur8, _feGaussianBlur9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelSketchO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "187.4mm",
    height: "129.57mm",
    viewBox: "0 0 187.4 129.57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter2363",
    x: -0.051766,
    y: -0.054179,
    width: 1.1035,
    height: 1.1084,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4922184
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2402",
    x: -0.088325,
    y: -0.086674,
    width: 1.1766,
    height: 1.1733,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.16357633
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2437",
    x: -0.088353,
    y: -0.086686,
    width: 1.1767,
    height: 1.1734,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.081034945
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1070",
    x: -0.025284,
    y: -0.025288,
    width: 1.0506,
    height: 1.0506,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.47098503
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1088",
    x: -0.024173,
    y: -0.035009,
    width: 1.0483,
    height: 1.07,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur5 || (_feGaussianBlur5 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.55512414
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1094",
    x: -0.047822,
    y: -0.037124,
    width: 1.0956,
    height: 1.0742,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur6 || (_feGaussianBlur6 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.86322895
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1181",
    x: -0.035796,
    y: -0.079193,
    width: 1.0792,
    height: 1.1378,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur7 || (_feGaussianBlur7 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.40921149
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1204",
    x: -0.022915,
    y: -0.037543,
    width: 1.0458,
    height: 1.0751,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur8 || (_feGaussianBlur8 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.39532192
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1227",
    x: -0.028554,
    y: -0.028365,
    width: 1.0571,
    height: 1.0567,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur9 || (_feGaussianBlur9 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15159269
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.669 5.2204)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.91545 0 0 .89309 2.4166 16.116)",
    d: "m91.555 91.334 20.96-9.325-2.0766-10.297s-1.1e-4 -0.75983 0.10354-1.0031c1.2559-2.9471 1.1609-2.0244 3.5435-4.9913 0.84208-1.0486 2.0348-3.3984 2.0348-3.3984 2.0417-4.0097 1.7939-9.304 1.3594-13.556-1.0562-10.955-8.2641-13.526-18.483-13.211-14.063-0.02242-17.835 6.255-19.397 10.013-0.76485 2.3997-1.631 5.0405-0.70331 8.1462 0.34533 1.156 0.63877 2.0771 0.1043 3.375l-1.1055 1.3146-3.2134 4.4705c-1.0125 1.7864 1.6485 2.2351 3.0836 3.2056l-1.2324 3.1784c-0.0572 0.12458 0.35663 0.20568 0.5931 0.27153 0.88714 0.17165 0.9818 0.15855 1.2695 0.2757 0.43034 0.17861 0.62861 0.58759 0.0684 0.93202l-1.1189 0.45914c-0.13568 0.04297-0.72553 0.37741-0.34326 0.87993l1.7244 2.3764c-0.87137 1.2356-1.1708 3.7945-0.23433 4.8493 3.363 2.3873 6.2053-0.1105 9.5682 0.16081z",
    style: {
      fillOpacity: 0.84946,
      filter: "url(#filter1094)",
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.075 96.826 19.273-8.3648-1.9094-9.2364s-1e-4 -0.68158 0.0952-0.89976c1.1548-2.6436 1.0674-1.8159 3.2583-4.4773 0.77429-0.9406 1.871-3.0485 1.871-3.0485 1.8774-3.5968 1.6495-8.3459 1.25-12.16-0.97118-9.8268-7.5988-12.133-16.995-11.85-12.931-0.02011-16.399 5.6109-17.836 8.9814-0.70328 2.1526-1.4997 4.5215-0.64669 7.3073 0.31752 1.037 0.58734 1.8632 0.0959 3.0275l-1.0165 1.1793-2.9547 4.0102c-0.93103 1.6024 1.5158 2.0049 2.8353 2.8755l-1.1332 2.8511c-0.05256 0.11175 0.32792 0.1845 0.54535 0.24357 0.81572 0.15397 0.90276 0.14222 1.1673 0.2473 0.3957 0.16022 0.57801 0.52708 0.06293 0.83604l-1.0288 0.41186c-0.12475 0.03855-0.66712 0.33855-0.31562 0.78932l1.5856 2.1317c-0.80122 1.1083-1.0765 3.4038-0.21546 4.3499 3.0922 2.1415 5.7057-0.09912 8.798 0.14425z",
    style: {
      fill: "#1b7387",
      fontVariationSettings: "normal",
      stopColor: "#000000",
      strokeMiterlimit: 7.4286,
      strokeWidth: 0.52917,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1845 0 0 1.095 -21.76 4.9905)",
    style: {
      fillOpacity: 0.8,
      filter: "url(#filter2363)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m94.424 61.231-0.0686-17.707c-0.33883-1.2043 0.21509-1.2423-1.4756-1.7158-0.99106 0.0028-1.76-0.02776-2.4364 1.0295-2.244-0.09994-2.7706 0.55182-3.4316 1.6472l-0.41179 1.6472c-0.74162 0.43972-1.0156 0.44497-1.5099 1.5442-0.61883 0.89093 5e-3 2.0769 0.0686 2.8825-1.1008 1.3453-1.1252 1.4495-1.2354 2.9855-0.10284 1.2333 0.2714 1.8956 1.5099 2.3678-0.17154 1.1719-0.37888 2.302-0.24022 3.2943 0.24096 1.0552 2.2379 2.1888 3.4808 1.9942-0.043 1.7416 1.2515 2.3111 2.2098 1.9298 2.7152 0.70175 2.7781-0.37318 3.5231-1.3846z",
    style: {
      fillOpacity: 0.8,
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.016 61.335 0.0243-16.961c0.0179-0.87019-0.0616-2.2327 1.7625-2.4454 1.7114-0.39809 2.2042-0.31771 3.379 0.92005 1.5942 0.0047 2.4334 0.17976 2.5775 1.4893 0.42717 1.0904 0.36449 1.5615 0.11371 2.175 1.3174 0.03179 1.3826 1.0671 1.6064 2.0103 0.63286 1.3119-0.0745 1.9784-0.63089 2.7177 1.6988 0.46638 1.8037 1.579 1.8441 2.7177 0.2413 2.1565-0.80918 2.0818-1.5044 2.6206 0.18561 1.0353 0.62105 2.0706-0.14559 3.1059-0.54232 1.4571-1.7152 1.7508-3.203 1.5044-0.86475 2.1798-1.9181 2.1907-2.9603 2.3294-1.7384-0.109-2.8601-0.70489-2.8633-2.1838z",
    style: {
      fillOpacity: 0.8,
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.965 45.137c0.83669 0.23056 2.3847 0.21374 1.6128 2.4536-2.8603 0.79767-0.40589 1.8133-0.80642 2.3335-0.69949 0.40569-3.0042 1.8932-3.5002-0.68632",
    style: {
      fillOpacity: 0.8,
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.701 57.632c1.5887-0.83085 2.1739-1.5055 2.6423-2.4364-0.41597-1.7745-1.066-2.0357-3.0924-2.1167",
    style: {
      fillOpacity: 0.8,
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.343 55.196c1.1538 0.47117 2.0097 3.1846 1.0933 4.1424",
    style: {
      fillOpacity: 0.8,
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.44 46.731c-1.5887 0.83085-2.1739 1.5055-2.6423 2.4364 0.16962 1.1523 0.76363 1.67 2.7453 1.3726",
    style: {
      fillOpacity: 0.8,
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.798 49.167c0.17652-2.2455-1.9825-2.7288-1.7501-3.5002",
    style: {
      fillOpacity: 0.8,
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.392 59.564c0.62174-1.1056 3.2376-1.7432 1.4779-3.1879-1.4141-0.87319-0.6779-2.3189 0.38365-2.8597 0.80864-0.2622 2.092-0.26087 3.1362 0.10396",
    style: {
      fillOpacity: 0.8,
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m89.774 71.195-0.07653-18.782c-0.37791-1.2774 0.2399-1.3177-1.6458-1.82-1.1054 0.0029-1.963-0.02944-2.7174 1.092-2.5028-0.10601-3.0902 0.58532-3.8274 1.7472l-0.45928 1.7472c-0.82716 0.46641-1.1327 0.47199-1.684 1.638-0.69021 0.94501 0.0056 2.203 0.07653 3.0575-1.2278 1.4269-1.255 1.5375-1.3779 3.1667-0.1147 1.3082 0.3027 2.0107 1.684 2.5115-0.19132 1.243-0.42258 2.4417-0.26793 3.4943 0.26875 1.1193 2.4961 2.3217 3.8823 2.1152-0.04796 1.8473 1.3959 2.4515 2.4647 2.0469 3.0283 0.74435 3.0985-0.39584 3.9295-1.4686z",
    style: {
      fill: "#f0908b",
      fontVariationSettings: "normal",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.549 71.305 0.02709-17.991c0.01996-0.92302-0.0687-2.3682 1.9658-2.5938 1.9087-0.42226 2.4585-0.337 3.7688 0.9759 1.7781 5e-3 2.714 0.19067 2.8747 1.5797 0.47645 1.1566 0.40653 1.6563 0.12684 2.3071 1.4694 0.03373 1.5421 1.1319 1.7916 2.1324 0.70586 1.3915-0.0832 2.0985-0.70365 2.8827 1.8948 0.4947 2.0117 1.6748 2.0568 2.8827 0.26909 2.2874-0.90253 2.2082-1.678 2.7797 0.20701 1.0982 0.69268 2.1963-0.16238 3.2945-0.60487 1.5455-1.9131 1.8571-3.5724 1.5958-0.96448 2.3121-2.1393 2.3237-3.3018 2.4709-1.9389-0.11562-3.19-0.74768-3.1935-2.3164z",
    style: {
      fill: "#f0908b",
      fontVariationSettings: "normal",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.8 54.123c0.93319 0.24456 2.6597 0.22672 1.7989 2.6025-3.1902 0.8461-0.4527 1.9234-0.89943 2.4751-0.78017 0.43032-3.3507 2.0081-3.9039-0.72798",
    style: {
      fill: "#f0908b",
      fontVariationSettings: "normal",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.275 67.377c1.7719-0.8813 2.4247-1.5969 2.9471-2.5843-0.46395-1.8822-1.189-2.1593-3.4491-2.2452",
    style: {
      fill: "#f0908b",
      fontVariationSettings: "normal",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.222 64.793c1.2869 0.49978 2.2415 3.378 1.2194 4.3939",
    style: {
      fill: "#f0908b",
      fontVariationSettings: "normal",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.714 55.814c-1.7719 0.8813-2.4247 1.5969-2.9471 2.5843 0.18918 1.2223 0.8517 1.7713 3.0619 1.456",
    style: {
      fill: "#f0908b",
      fontVariationSettings: "normal",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.767 58.398c0.19687-2.3819-2.2111-2.8945-1.952-3.7127",
    style: {
      fill: "#f0908b",
      fontVariationSettings: "normal",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.199 69.426c0.69345-1.1727 3.6111-1.849 1.6483-3.3815-1.5772-0.9262-0.75608-2.4597 0.42791-3.0333 0.9019-0.27812 2.3332-0.27671 3.498 0.11028",
    style: {
      fill: "#f0908b",
      fontVariationSettings: "normal",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.8748 0 0 1.7986 -106.35 -36.482)",
    d: "m121.66 46.829c0-1.2488 1.0001-2.2647 2.2224-2.2647 1.2276 0 2.2224 1.016 2.2224 2.2647 0 1.2541-0.99479 2.2647-2.2224 2.2647-1.2223 0-2.2224-1.0107-2.2224-2.2647",
    style: {
      fillOpacity: 0.8,
      filter: "url(#filter2402)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.85 47.03c0-2.1088 1.6638-3.8244 3.6974-3.8244 2.0424 0 3.6975 1.7156 3.6975 3.8244 0 2.1177-1.6551 3.8244-3.6975 3.8244-2.0336 0-3.6974-1.7067-3.6974-3.8244",
    style: {
      fill: "#1b7387",
      strokeMiterlimit: 7.4286,
      strokeWidth: 0.6,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 41.834473,
    y: 4.166748,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "7.0556px",
      letterSpacing: 0,
      lineHeight: "125%",
      strokeWidth: 0.265,
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 41.834473,
    y: 4.166748,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "7.0556px",
      strokeWidth: 0.265
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 41.834473,
    y: 13.797108,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "9.8778px",
      strokeWidth: 0.265
    }
  }, "Perception")), /*#__PURE__*/React.createElement("text", {
    x: 115.8361,
    y: -16.440304,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "7.0556px",
      letterSpacing: 0,
      lineHeight: "125%",
      strokeWidth: 0.26458,
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 115.8361,
    y: -16.440304,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "7.0556px",
      strokeWidth: 0.26458
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 115.8361,
    y: -7.6208539,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "7.0556px",
      strokeWidth: 0.26458
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 115.8361,
    y: 2.009506,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "9.8778px",
      strokeWidth: 0.26458
    }
  }, "Interpretation")), /*#__PURE__*/React.createElement("path", {
    d: "m13.001 48.115 55.115 19.028-55.115 19.028z",
    style: {
      fillOpacity: 0.70161,
      filter: "url(#filter1088)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.399 45.81 55.115 19.028-55.115 19.028z",
    style: {
      fill: "#1b7387",
      strokeMiterlimit: 7.4286,
      strokeWidth: 0.7,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.006 52.62v22.946h-8.5169v-22.946z",
    style: {
      fillRule: "evenodd",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.011 60.171 25.157 0.27864-0.10341 7.7674-25.157-0.27864z",
    style: {
      fillRule: "evenodd",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.997 72.802v5.0975h-3.403v-5.0975z",
    style: {
      fillRule: "evenodd",
      fill: "#0ac29b",
      strokeMiterlimit: 7.4286,
      strokeOpacity: 0.91765,
      strokeWidth: 0.1,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.673 61.482 5.9449 0.02034-0.0186 3.1037-5.9449-0.02035z",
    style: {
      fillRule: "evenodd",
      fill: "#f15250",
      strokeMiterlimit: 7.4286,
      strokeOpacity: 0.91765,
      strokeWidth: 0.1,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.95984 0 0 .95118 9.3273 7.1229)",
    d: "m168.6 23.733a22.353 22.35 0 0 1-22.223 22.35 22.353 22.35 0 0 1-22.481-22.09 22.353 22.35 0 0 1 21.962-22.606 22.353 22.35 0 0 1 22.737 21.827",
    style: {
      fillOpacity: 0.66667,
      filter: "url(#filter1070)",
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.18 27.951a21.116 20.926 0 0 1-20.652 21.366 21.116 20.926 0 0 1-21.571-20.455 21.116 20.926 0 0 1 20.631-21.386 21.116 20.926 0 0 1 21.591 20.434",
    style: {
      fill: "#1b7387",
      paintOrder: "stroke fill markers",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.95 11.782v32.041h-11.538v-32.041z",
    style: {
      fillRule: "evenodd",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.28 22.325 34.079 0.38907-0.14008 10.846-34.079-0.38906z",
    style: {
      fillRule: "evenodd",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.22 19.054-1.8412 2.8637h1.2272v18.144h1.2276v-18.144h1.2276z",
    style: {
      fill: "#0ac29b",
      strokeLinejoin: "round",
      strokeOpacity: 0.91765,
      strokeWidth: 0.1,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.77 24.561-2.8407 1.7189 2.8243 1.743 6e-3 -1.1541 17.948 0.07667 5e-3 -1.1541-17.947-0.07667z",
    style: {
      fill: "#f15250",
      strokeLinejoin: "round",
      strokeOpacity: 0.91765,
      strokeWidth: 0.1,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.62 24.155 7.5482 0.02841-0.0236 4.3338-7.5482-0.02841z",
    style: {
      fillRule: "evenodd",
      fill: "#f15250",
      strokeOpacity: 0.91765,
      strokeWidth: 0.1,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.8 24.186h4.6099v4.3099h-4.6099z",
    style: {
      fill: "#fff",
      strokeMiterlimit: 8,
      strokeWidth: 0.5,
      stroke: "#d32020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.4 39.345-3e-3 7.4801-4.3733-0.0088 3e-3 -7.4801z",
    style: {
      fillRule: "evenodd",
      fill: "#0ac29b",
      strokeOpacity: 0.91765,
      strokeWidth: 0.1,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.8 24.659 3.6456 3.9231",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stopColor: "#000000",
      strokeWidth: 0.4,
      stroke: "#d32020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.25 24.093 3.0824 3.6231",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stopColor: "#000000",
      strokeWidth: 0.4,
      stroke: "#d32020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.65 26.238 2.1981 2.3355",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stopColor: "#000000",
      strokeWidth: 0.4,
      stroke: "#d32020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.64 24.072 1.8528 2.1446",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stopColor: "#000000",
      strokeWidth: 0.4,
      stroke: "#d32020"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 81.909721,
    y: 114.57078,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "7.0556px",
      letterSpacing: 0,
      lineHeight: "125%",
      strokeWidth: 0.26458,
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 81.909721,
    y: 114.57078,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "7.0556px",
      strokeWidth: 0.26458
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 81.909721,
    y: 124.20113,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "9.8778px",
      strokeWidth: 0.26458
    }
  }, "Action "), /*#__PURE__*/React.createElement("tspan", {
    x: 81.909721,
    y: 133.02058,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "7.0556px",
      strokeWidth: 0.26458
    }
  })), /*#__PURE__*/React.createElement("text", {
    x: 157.56711,
    y: 52.859661,
    style: {
      fill: "#ffffff",
      fontFamily: "Calibri",
      fontSize: "7.0556px",
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: "125%",
      strokeWidth: 0.26458,
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 157.56711,
    y: 52.859661,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "7.0556px",
      fontWeight: "normal",
      strokeWidth: 0.26458
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 157.56711,
    y: 62.753407,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "9.8778px",
      fontWeight: "bold",
      strokeWidth: 0.26458
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontFamily: "Verdana",
      fontSize: "9.8778px",
      fontWeight: "normal"
    }
  }, "Decision")), /*#__PURE__*/React.createElement("tspan", {
    x: 157.56711,
    y: 71.572861,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "7.0556px",
      fontWeight: "normal",
      strokeWidth: 0.26458
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m57.01 44.361v-11.056c0-6.1063 6.3959-11.056 14.286-11.056h18.955v-3.159l8.1633 6.3179-8.1633 6.3179v-3.159h-18.955c-3.3808 0-6.1224 2.1218-6.1224 4.7384v11.056z",
    style: {
      fillOpacity: 0.7,
      filter: "url(#filter1181)",
      strokeMiterlimit: 7.4286,
      strokeOpacity: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.256 43.602v-11.056c0-6.1063 6.3959-11.056 14.286-11.056h18.955v-3.159l8.1633 6.3179-8.1633 6.3179v-3.159h-18.955c-3.3808 0-6.1224 2.1218-6.1224 4.7384v11.056z",
    style: {
      fill: "#1b7387",
      strokeMiterlimit: 7.4286,
      strokeWidth: 0.7,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0477 0 0 1.0625 -23.26 -17.879)",
    d: "m169.48 68.978v11.056c0 6.1063-6.3959 11.056-14.286 11.056h-18.955v3.159l-8.1633-6.3179 8.1633-6.3179v3.159h18.955c3.3808 0 6.1224-2.1218 6.1224-4.7384v-11.056z",
    style: {
      fillOpacity: 0.7,
      filter: "url(#filter1204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.25 55.157v11.056c0 6.1063-6.3959 11.056-14.286 11.056h-18.955v3.159l-8.1633-6.3179 8.1633-6.3179v3.159h18.955c3.3808 0 6.1224-2.1218 6.1224-4.7384v-11.056z",
    style: {
      fill: "#1b7387",
      strokeMiterlimit: 7.4286,
      strokeWidth: 0.7,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.94 67.084-1.7022 1.7755 1.9068 1.9891-1.9068 1.9888 1.7022 1.7755 1.9071-1.9891 1.9068 1.9891 1.7022-1.7755-1.9071-1.9888 1.9071-1.9891-1.7022-1.7755-1.9068 1.9888z",
    style: {
      fill: "#1b7387",
      paintOrder: "stroke markers fill",
      strokeLinejoin: "round",
      strokeWidth: 0.8,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.86 66.975-3.4967 3.8743-1.9949-2.1881-1.4205 1.5882 2.2829 2.5032 1.134 1.2567 4.9216-5.4531z",
    style: {
      fill: "#1b7387",
      paintOrder: "stroke markers fill",
      strokeLinejoin: "round",
      strokeWidth: 0.8,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0657 0 0 1.0871 -35.384 2.1916)",
    d: "m123.22 102.69-6.3708-6.3708h3.1854v-6.4555h6.3708v6.4555h3.1854z",
    style: {
      fillOpacity: 0.7,
      fillRule: "evenodd",
      filter: "url(#filter1227)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.621 112.64-6.3708-6.3708h3.1854v-6.4555h6.3708v6.4555h3.1854z",
    style: {
      fillRule: "evenodd",
      fill: "#1b7387",
      strokeWidth: 0.7,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(2.2867 0 0 2.2371 -155.92 -60.232)",
    d: "m118.41 50.561c0-0.6191 0.49739-1.1218 1.1006-1.1218 0.60851 0 1.1006 0.50268 1.1006 1.1218 0 0.62438-0.4921 1.1218-1.1006 1.1218-0.60322 0-1.1006-0.49739-1.1006-1.1218",
    style: {
      fillOpacity: 0.8,
      filter: "url(#filter2437)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.25 52.638c0-1.0426 0.87537-1.8892 1.937-1.8892 1.0709 0 1.937 0.84656 1.937 1.8892 0 1.0515-0.86606 1.8892-1.937 1.8892-1.0616 0-1.937-0.83766-1.937-1.8892",
    style: {
      fill: "#1b7387",
      strokeMiterlimit: 7.4286,
      strokeWidth: 0.5,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.97916 1.0213)",
    x: 161.1312,
    y: 73.139839,
    style: {
      fill: "#1b7387",
      fontFamily: "Verdana",
      fontSize: "10.403px",
      fontWeight: "bold",
      letterSpacing: 0,
      lineHeight: 1.25,
      paintOrder: "stroke markers fill",
      strokeLinejoin: "round",
      strokeWidth: 0.8,
      stroke: "#ffffff",
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 161.1312,
    y: 73.139839,
    style: {
      fill: "#1b7387",
      fontFamily: "Verdana",
      fontSize: "10.403px",
      fontWeight: "bold",
      paintOrder: "stroke markers fill",
      strokeLinejoin: "round",
      strokeWidth: 0.8,
      stroke: "#ffffff"
    }
  }, "?"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelSketchO);
export default __webpack_public_path__ + "static/media/ModelSketchO.5606912d9eb8a64d502c494f5c5726a2.svg";
export { ForwardRef as ReactComponent };